<h1 mat-dialog-title>{{ getDialogTitle() | translate }}</h1>

<div mat-dialog-content>
  <form [formGroup]="leagueForm">
    <mat-form-field [style.width.px]="350" appearance="outline" style="margin-top: 0.5rem">
      <mat-label>{{ 'League Name' | translate }}</mat-label>
      <input formControlName="name" matInput placeholder="{{ 'Enter league name' | translate }}"/>
      <mat-error *ngIf="leagueForm.get('name')?.invalid && leagueForm.get('name')?.touched">
        {{ 'Name is required' | translate }}
      </mat-error>
      <mat-icon matSuffix matTooltip="The name of the league should be the same from Categories" matTooltipPosition="above">
        info
      </mat-icon>
    </mat-form-field>
    <mat-form-field [style.width.px]="350" appearance="outline" style="margin-top: 0.5rem">
      <mat-label>{{ 'Number of teams' | translate }}</mat-label>
      <input formControlName="numberOfTeams" matInput placeholder="{{ 'Enter Number of teams' | translate }}"/>
      <mat-error *ngIf="leagueForm.get('numberOfTeams')?.invalid && leagueForm.get('numberOfTeams')?.touched">
        {{ 'Number of Teams is required' | translate }}
      </mat-error>
      <mat-icon matSuffix matTooltip="Determine the number of teams for this league" matTooltipPosition="above">
        info
      </mat-icon>
    </mat-form-field>
    <mat-form-field [style.width.px]="350" appearance="outline" style="margin-top: 0.5rem">
      <mat-label>{{ 'Total game weeks' | translate }}</mat-label>
      <input formControlName="totalGameWeeks" matInput placeholder="{{ 'Enter number of Total game weeks' | translate }}"/>
      <mat-error *ngIf="leagueForm.get('totalGameWeeks')?.invalid && leagueForm.get('totalGameWeeks')?.touched">
        {{ 'Total game week is required' | translate }}
      </mat-error>
      <mat-icon matSuffix matTooltip="Determine the number of game weeks for this season" matTooltipPosition="above">
        info
      </mat-icon>
    </mat-form-field>
  </form>
</div>

<div mat-dialog-actions>
  <button (click)="onCancel()" mat-button>{{ 'Cancel' | translate }}</button>
  <button (click)="onSave()" [disabled]="leagueForm.invalid" color="primary" mat-button>
    {{ getCreateOrUpdate() | translate }}
  </button>
</div>
